/**
 * Error constants
 */

export const ERR_UNKNOWN_ERR = 'Unknown error'
